import { LazyLoad } from 'app/utils';

export const SurveyResponseListPage = LazyLoad(
  () => import('./index'),
  (module) => module.SurveyResponseListPage,
);
